// extracted by mini-css-extract-plugin
module.exports = {"row":"IncidentSummaryTile_row__3ZbwF","value":"IncidentSummaryTile_value__aefjD","horizontalDivider":"IncidentSummaryTile_horizontalDivider__3yfMQ"};